export type Period = 'am' | 'pm'
export type VTimePickerViewMode = 'hour' | 'minute' | 'second'
